export const BET_TO_IDX = {
  Zero: 0,
  DoubleZero: 1,
  R1: 2,
  B2: 3,
  R3: 4,
  B4: 5,
  R5: 6,
  B6: 7,
  R7: 8,
  B8: 9,
  R9: 10,
  B10: 11,
  B11: 12,
  R12: 13,
  B13: 14,
  R14: 15,
  B15: 16,
  R16: 17,
  B17: 18,
  R18: 19,
  R19: 20,
  B20: 21,
  R21: 22,
  B22: 23,
  R23: 24,
  B24: 25,
  R25: 26,
  B26: 27,
  R27: 28,
  B28: 29,
  B29: 30,
  R30: 31,
  B31: 32,
  R32: 33,
  B33: 34,
  R34: 35,
  B35: 36,
  R36: 37,
  Red: 38,
  Black: 39,
  Even: 40,
  Odd: 41,
  Col1: 42,
  Col2: 43,
  Col3: 44,
  Dozen1: 45,
  Dozen2: 46,
  Dozen3: 47,
  Low: 48,
  High: 49,
};

export const BET_TO_NUMBER = {
  Zero: 0,
  R1: 1,
  B2: 2,
  R3: 3,
  B4: 4,
  R5: 5,
  B6: 6,
  R7: 7,
  B8: 8,
  R9: 9,
  B10: 10,
  B11: 11,
  R12: 12,
  B13: 13,
  R14: 14,
  B15: 15,
  R16: 16,
  B17: 17,
  R18: 18,
  R19: 19,
  B20: 20,
  R21: 21,
  B22: 22,
  R23: 23,
  B24: 24,
  R25: 25,
  B26: 26,
  R27: 27,
  B28: 28,
  B29: 29,
  R30: 30,
  B31: 31,
  R32: 32,
  B33: 33,
  R34: 34,
  B35: 35,
  R36: 36,
  DoubleZero: 37,
};

export const NUMBER_TO_COLOR = {
  1: "R",
  2: "B",
  3: "R",
  4: "B",
  5: "R",
  6: "B",
  7: "R",
  8: "B",
  9: "R",
  10: "B",
  11: "B",
  12: "R",
  13: "B",
  14: "R",
  15: "B",
  16: "R",
  17: "B",
  18: "R",
  19: "R",
  20: "B",
  21: "R",
  22: "B",
  23: "R",
  24: "B",
  25: "R",
  26: "B",
  27: "R",
  28: "B",
  29: "B",
  30: "R",
  31: "B",
  32: "R",
  33: "B",
  34: "R",
  35: "B",
  36: "R",
};
